import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import SectionLoader from "../../LodingScreen/SectionLoader";
import { useTranslation } from "react-i18next";
import Loader from "react-loader-spinner";

const FaqTab = () => {
  const { t } = useTranslation();
  const [active, setActive] = useState<any>("");
  const [filter, setFilter] = useState("");
  const [faq, setFaq] = useState<any[]>([]);
  const faqData: any[] = useSelector((state: any) => state.dashboard.faq);
  const handleOpen = (val: any) => setActive(val);
  const commonLoading: any = useSelector((state: any) => (state.common.loader ? state.common.loader : false));
  useEffect(() => {
    if (faqData && Array.isArray(faqData) && faqData?.length > 0) {
      setFilter(faqData[0]?.CategoryId);
      setActive(false);
    }
    return () => {};
  }, [faqData]);

  useEffect(() => {
    if (filter && faqData && Array.isArray(faqData) && faqData?.length > 0) {
      let arr = faqData?.filter((ele: any) => {
        return ele.CategoryId === filter;
      });
      setFaq(arr[0]?.Faqs);
      setActive(false);
    }
    return () => {};
  }, [filter]);
  return (
    <div className="tc_box">
      <div className="heading_box">Frequently Asked Questions</div>
      {commonLoading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader type="ThreeDots" color="#fff" height={100} width={100} />
        </div>
      ) : (
        <div className="faqbox">
          <div className="d-flex flex-wrap align-items-center" style={{ columnGap: "20px" }}>
            {faqData && Object.keys(faqData)?.length > 0 ? (
              <>
                {faqData &&
                  faqData?.length > 0 &&
                  faqData?.map((item: any, i: any) => (
                    <div key={item?.CategoryId}>
                      <button
                        type="submit"
                        onClick={(e: any) => setFilter(item?.CategoryId)}
                        className={filter === item?.CategoryId ? "book--hexagon faq active" : "book--hexagon faq"}
                        key={i}
                      >
                        <span className="text-capitalize">{item?.Category}</span>
                      </button>
                    </div>
                  ))}
              </>
            ) : (
              <SectionLoader />
            )}
          </div>
          <ul className="faq_list">
            {faqData && Object.keys(faqData)?.length > 0 ? (
              <>
                {faq.length > 0 ? (
                  faq?.map((item2: any, i: any) => (
                    <li key={item2?.id}>
                      <div
                        className="question"
                        onClick={(e) => {
                          active == false || active != item2?.faq_category_id + i
                            ? setActive(item2?.faq_category_id + i)
                            : setActive(false);
                        }}
                      >
                        <span>{item2?.title}</span>
                        <i className={active == item2?.faq_category_id + i ? "fa fa-angle-up" : "fa fa-angle-down"}></i>
                      </div>
                      {active == item2?.faq_category_id + i && (
                        <div
                          className="answer"
                          dangerouslySetInnerHTML={{
                            __html: item2?.description ? item2?.description : "",
                          }}
                        ></div>
                      )}
                    </li>
                  ))
                ) : (
                  <div className="text-center text-dark p-3 bg-white">{t("no_faq_desc")}</div>
                )}
              </>
            ) : (
              <SectionLoader />
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default FaqTab;
